
import { EVENTS } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlClientClose extends Vue {
  domTriggersSelector = '.panel--basket .go-pay';
  domTriggerEvent = 'click';

  mounted() {
    document.addEventListener(this.domTriggerEvent, this.eventListener);
  }

  eventListener(event) {
    if (this.isDomTriggerTarget(event)) {
      this.$x.emit(EVENTS.CloseEmpathyX);
    }
  }

  isDomTriggerTarget(event): boolean {
    const domTrigger = document.querySelector(this.domTriggersSelector);
    return domTrigger && (event.target === domTrigger || domTrigger.contains(event.target));
  }

  // Needed as this component doesn't have template
  render() {}
}
